import React from "react";
import { useSelector } from "react-redux";
import "./insurance-info.scss";

export default function InsuranceInfo(props) {
  const { insuranceData } = props;

  // const { contactDetails } = useSelector(({ user }) => ({
  //   contactDetails: user.contactDetails
  // }));

  return (
    <div className="insurance-info-container">
      <span>{insuranceData.insuranceToDisable.insuranceCompany.code}</span>
      <span>{insuranceData.insuranceToDisable.productDesc}</span>
      <span>{insuranceData.insuranceToDisable.policyNumber}</span>
      {/* {contactDetails && contactDetails.email && (
        <span>{contactDetails.email}</span>
      )} */}
    </div>
  );
}
